const paths = {
  listOrganization: '/organization/list',
  editOrganization: '/organization/edit'
};

export default paths;
